import { render } from "./PricingSection.vue?vue&type=template&id=688f4ed8"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tim-k\\WebstormProjects\\wsstart\\node_modules\\.pnpm\\vue-loader@17.0.0_webpack@5.72.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__